module.exports = __webpack_public_path__ + "static/media/icon-dot-gov.ea3237dd.svg";